// extracted by mini-css-extract-plugin
module.exports = {"Result":"SearchResult_Result__1Et9T","Author":"SearchResult_Author__1apoe"};